import { IconBase } from "./iconBase.js";
import { Fragment, jsx, jsxs } from "@emotion/react/jsx-runtime";
//#region src/pause.tsx
var Pause = ({ type, ...rest }) => /* @__PURE__ */ jsx(IconBase, {
	viewBox: "0 0 24 24",
	...rest,
	children: type === "stroke" ? /* @__PURE__ */ jsxs(Fragment, { children: [/* @__PURE__ */ jsx("rect", {
		x: "6",
		y: "4",
		width: "4",
		height: "16",
		rx: "1",
		stroke: "currentColor",
		strokeWidth: "1.5",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ jsx("rect", {
		x: "14",
		y: "4",
		width: "4",
		height: "16",
		rx: "1",
		stroke: "currentColor",
		strokeWidth: "1.5",
		strokeLinejoin: "round"
	})] }) : /* @__PURE__ */ jsxs(Fragment, { children: [/* @__PURE__ */ jsx("rect", {
		x: "6",
		y: "4",
		width: "4",
		height: "16",
		rx: "1",
		fill: "currentColor"
	}), /* @__PURE__ */ jsx("rect", {
		x: "14",
		y: "4",
		width: "4",
		height: "16",
		rx: "1",
		fill: "currentColor"
	})] })
});
//#endregion
export { Pause };
